"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * settings: {
 *     button: {
 *         type: "unarchive",
 *         label: "",
 *         withTooltip: false,
 *         tooltipText: "",
 *         className: "btn-xs btn-info",
 *         icon: {
 *             name: "pencil",
 *             paths: [
 *                  "M864 0c88.364 0 160 71.634 160 160 0 36.020-11.91 69.258-32 96l-64 64-224-224 64-64c26.742-20.090 59.978-32 96-32zM64 736l-64 288 288-64 592-592-224-224-592 592zM715.578 363.578l-448 448-55.156-55.156 448-448 55.156 55.156z"
 *             ],
 *             viewBox: "0 0 1024 1024"
 *        },
 *        action: {
 *            name: "unArchive"
 *        }
 *    }
 * }
 */

var actionType = 'singleButton';
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var button = settings.button;
    var noIcon = !button.icon;
    var buttonNode = /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: noIcon ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: '15px',
          display: 'flex',
          alignItems: 'center'
        }
      }, button.label) : /*#__PURE__*/_react["default"].createElement("span", {
        className: "icon"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: "15",
        height: "15",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: button.icon.viewBox
      }, /*#__PURE__*/_react["default"].createElement("g", null, button.icon.paths.map(function (p) {
        return /*#__PURE__*/_react["default"].createElement("path", {
          key: p,
          d: p
        });
      }))), " ".concat(button.label)),
      className: 'btn ' + button.className + ' ' + _style["default"].button,
      onClick: function onClick() {
        if (button.action) {
          callbackHandler("".concat(actionType, "::").concat(button.action.name), {
            row: row
          });
        } else {
          callbackHandler("".concat(actionType, "::").concat(button.type), {
            row: row
          });
        }
      }
    }));
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('table-renderers-single-button', 'text-nowrap')
    }, button.withTooltip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: button.tooltipText ? button.tooltipText : button.label
    }, buttonNode), !button.withTooltip && /*#__PURE__*/_react["default"].createElement("span", null, buttonNode));
  };
};